<template>
  <v-container
  class="ma-0 pa-0"
  fluid
  >
    <v-row
    class="ma-0 pa-0"
    >
      <v-col cols="12">
        <GraphDataOG0
        :update="update"
        :code="code"
        category="outgoing"
        />
      </v-col>
      <v-col cols="12">
        <GraphDataOG1
        :DataList="DataList"
        :update="update"
        :code="code"
        category="outgoing"
        />
      </v-col>
      <v-col cols="12">
        <GraphDataOG2
        :DataList="DataList"
        :update="update"
        :code="code"
        category="outgoing"
        />
      </v-col>
      <v-col cols="12">
        <GraphDataOG3
        :DataList="DataList"
        :update="update"
        :code="code"
        category="outgoing"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GraphDataOG3 from '../Output/GraphDataOG3'
import GraphDataOG0 from '../Output/GraphDataOG0'
import GraphDataOG1 from '../Output/GraphDataOG1'
import GraphDataOG2 from '../Output/GraphDataOG2'

export default {
  name: 'OutgoingInfo',
  components: {
    GraphDataOG0,
    GraphDataOG1,
    GraphDataOG2,
    GraphDataOG3
  },
  props: {
    update: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    DataList: {
      type: Array,
      default: null
    }
  },
  methods: {
    updateData () {
    }
  },
  watch: {
    update () {
      this.updateData()
    }
  }
}
</script>

<style scoped>

</style>
